import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Checkbox, Button, Dimmer, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import * as AppActions from '../../../actions';
import domains from '../../../containers/Domains';

const { featureFlags } = domains || {};
const { adPreview: adPreviewFlagObj } = featureFlags || {};
const { campaignRestructuringEnabled } = adPreviewFlagObj || {};

class ToggleComponents extends Component {
  state = {
    noAdsSelected: false,
    loading: false
  };
  handleDisplayCopy = () => {
    this.props.actions.displayCopyButtons();
  };

  handleExpandAll = () => {
    const { actions, expandAll } = this.props;
    const url = window.location.href;
    const urlParts = url.split('#');
    if (urlParts[1]) {
      const params = urlParts[1].split('&');
      const showAllParam = _.find(
        params,
        (p) => p && p.indexOf('showAll=') !== -1
      );
      let newUrl = url;
      if (showAllParam) {
        const showAllStartingIndex = url.indexOf('&showAll=');
        const slicedUrl = url.slice(0, showAllStartingIndex);
        newUrl = `${slicedUrl}&showAll=${!expandAll}`;
      } else {
        newUrl = `${url}&showAll=${!expandAll}`;
      }
      window.location.replace(newUrl);
    }
    actions.expandAll();
  };

  handleCompareDefault = () => {
    this.props.actions.compareMobileDesktop();
  };

  resetSelectedAds = () => {
    const { resetReduxSelectedAds } = this.props;
    if (resetReduxSelectedAds) resetReduxSelectedAds();
    this.setState({
      noAdsSelected: true
    });
  };

  selectAllAds = () => {
    const { selectAllAdsInRedux } = this.props;
    if (selectAllAdsInRedux) selectAllAdsInRedux();
    this.setState({
      noAdsSelected: false
    });
  };

  restructureCampaigns = () => {
    const { restructureCampaigns } = this.props;
    const { campaignRestructured } = this.state;
    this.setState({ loading: true });
    setTimeout(() => {
      if (restructureCampaigns) restructureCampaigns();
      this.setState(
        {
          campaignRestructured: !campaignRestructured,
          loading: false
        },
        () => {
          const {
            campaignRestructured: updatedCampaignRestructured
          } = this.state;
          toast.info(
            `Ads sorted by ${
              !updatedCampaignRestructured
                ? 'Fb Campaign Objective'
                : 'Constellation Objective'
            }`,
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            }
          );
        }
      );
    }, 750);
  };

  render() {
    const { loading } = this.state;
    const {
      adPreviewMultiQc,
      expandAll,
      displayCopy,
      compareMobDesk,
      campaignRestructured: campaignRestructuredProp,
      processing
    } = this.props;
    const { campaignRestructured } = this.state;
    const { noAdsSelected } = this.state;
    return (
      <Grid columns={7} stackable verticalAlign="middle">
        <Grid.Row>
          <Grid.Column style={{ width: '16%' }}>
            <Checkbox
              label={{ children: 'Expand All Ads' }}
              toggle
              onChange={this.handleExpandAll}
              checked={expandAll}
            />
          </Grid.Column>
          <Grid.Column style={{ width: '19%' }}>
            <Checkbox
              label={{ children: 'Display Copy Buttons' }}
              toggle
              onChange={this.handleDisplayCopy}
              checked={displayCopy}
            />
          </Grid.Column>
          <Grid.Column style={{ width: '22%' }}>
            <Checkbox
              label={{ children: 'Compare Mobile & Desktop' }}
              toggle
              onChange={this.handleCompareDefault}
              checked={compareMobDesk}
            />
          </Grid.Column>
          <Grid.Column>
            {campaignRestructuringEnabled ? (
              <Dimmer.Dimmable dimmed={loading}>
                <Dimmer active={loading} inverted>
                  <Loader size="mini">Sorting</Loader>
                </Dimmer>
                <div style={{ float: 'left', marginTop: '5%' }}>Sort:</div>
                <div style={{ float: 'right' }}>
                  <Button
                    disabled={processing}
                    onClick={this.restructureCampaigns}
                    basic
                    color="teal"
                  >
                    {campaignRestructured || campaignRestructuredProp
                      ? 'Facebook'
                      : 'Constellation'}
                  </Button>
                </div>
              </Dimmer.Dimmable>
            ) : null}
          </Grid.Column>
          <Grid.Column>
            <div style={{ float: 'right' }}>
              <Button
                disabled={processing}
                onClick={
                  noAdsSelected ? this.selectAllAds : this.resetSelectedAds
                }
                basic
                color={'orange'}
              >
                {noAdsSelected ? 'Select All Ads' : 'Reset Selected Ads'}
              </Button>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div style={{ float: 'right' }}>{adPreviewMultiQc || null}</div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  expandAll: state.adPreview.expandAllAds,
  displayCopy: state.adPreview.displayCopyButtons,
  compareMobDesk: state.adPreview.compareMobileDesktop
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ToggleComponents);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/ToggleComponents.js